import { ReactNode } from 'react';

import Close from '@mui/icons-material/Close';
import { Link, Typography } from '@mui/material';

import styled from 'styled-components';

import { CONFIG } from '@arrived/config';

import { TextWrapper } from '../../../TextWrapper';

const StyledWhichPropertyPopoverContent = styled.div`
  &.which-property-popover-content {
    max-width: 450px;
    padding: ${({ theme }) => theme.spacing(2)};
    position: relative;

    .which-property-popover-content-close {
      cursor: pointer;
      position: absolute;
      top: ${({ theme }) => theme.spacing(2)};
      right: ${({ theme }) => theme.spacing(2)};
    }
  }
`;

export interface WhichPropertyPopoverContentProps {
  handleOnClose: () => void;
}

export const WhichPropertyPopoverContent = ({ handleOnClose }: WhichPropertyPopoverContentProps) => {
  return (
    <StyledWhichPropertyPopoverContent className="which-property-popover-content">
      <Close className="which-property-popover-content-close" onClick={handleOnClose} />
      <TextWrapper
        formattedMessageProps={{
          id: 'which-property-popover-content',
          defaultMessage: `First we focus on acquiring the right homes by
            <ol>
              <li>Identifying the most lucrative markets</li>
              <li>Narrowing down the top neighborhoods</li>
              <li>Defining the ideal home purchasing criteria</li>
              <li>Sourcing deals to find the right home</li>
              <li>Understanding the value and making the right offer</li>
              <li>Investing in renovation strategically</li>
            </ol>
            Once we own the property we focus on the second part which is managing rental properties efficiently by
            <ol>
              <li>Selecting experienced and motivated property managers</li>
              <li>Finding great tenants and align incentives</li>
              <li>Deploying technology to run efficient operations</li>
              <li>Leveraging scale to reduce costs</li>
            </ol>
            <link>Learn More</link>`,
          values: {
            ol: (chunk: ReactNode) => <ol>{chunk}</ol>,
            li: (chunk: ReactNode) => <li>{chunk}</li>,
            link: (chunk: ReactNode) => (
              <Link
                href={`${CONFIG.learnBlogUrl}/how-to-make-money-investing-in-sfrs-the-arrived-process/`}
                target="_blank"
              >
                <Typography variant="body1">{chunk}</Typography>
              </Link>
            ),
          },
        }}
      />
    </StyledWhichPropertyPopoverContent>
  );
};
